import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'LimitDisplayNumber',
  standalone: true,
})
export class LimitDisplayNumberPipe implements PipeTransform {
  transform(value: number | null | undefined, max?: number): string | null | undefined {
    if (!value || !max) {
      return value?.toString();
    }

    if (value <= max) {
      return value.toString();
    }

    return `${max}+`;
  }
}
